import React from 'react';

import './header.styles.css';



const Header = props => (
    <div className="header">
       <header className="header">
            <div className="header__logo-box">
                <img src="img/logo-greben.png" alt="Logo" className="header__logo"></img>
            </div>
            <div className="header__text-box">
                <h1 className="heading-primary">
                    <span className="heading-primary--main">Greben</span>
                    <span className="heading-primary--sub">Planinarski Klub</span>
                </h1>
                <a onClick={props.scrollTo} className="btn btn--white btn--animated">Pogledaj Naše Akcije</a>
            </div>
        </header>        
    </div>
);


export default Header;